export default function currencyChecker(currency) {
  if (currency === 'BRL') return 'R$';

  return currency
}
